export const projects = [
  {
    slug: "amstelveen",
    title: "Een eigen ontwerp, toch prefab",
    place: "Amstelveen",
    status: "Loopt",
    image: "/villa-elementa.jpg",
    imageAlt: "Ontwerpimpressie van een moderne villa",
    label: "Impressie",
    intro:
      "Dit soort tekeningen krijgen we vaker binnen dan je denkt. Een architect heeft precies getekend wat iemand wil, en dan begint de rondgang langs bouwers. De een vindt het te groot voor zijn model, de ander vindt de gevel te afwijkend, de derde wil de plattegrond aanpassen. In Amstelveen kwam iemand na drie van die gesprekken bij ons, met dezelfde tekening.",
    approach:
      "We zijn niet begonnen met wat eraf moest. We zijn begonnen met wat erop moest blijven, en dat hebben we op een lijstje gezet: de hoogte van de woonkamer, de pui aan de tuinkant, de manier waarop het dak over de gevel hangt. Daarna hebben we per onderdeel bepaald hoe de fabriek het maakt. Het meeste kon gewoon. Een paar dingen vroegen om een andere constructie, niet om een andere tekening, en dat soort keuzes leggen we voor voordat er iets besteld wordt, samen met wat het kost.",
    progress:
      "Het project zit in de voorbereiding. De tekeningen worden klaargemaakt voor de fabriek en per onderdeel staat op papier wie wat doet. Het beeld op deze pagina is een impressie die wij hebben gemaakt, geen foto. Een bouwtijd, een opleverdatum en een prijs komen pas als het huis er staat.",
  },
  {
    slug: "villa-aan-het-water",
    title: "Wonen aan het water",
    place: "Ontwerpstudie",
    status: "Ontwerpstudie",
    image: "/villa-avond.jpg",
    imageAlt: "Ontwerpimpressie van een villa aan het water bij avondlicht",
    label: "Ontwerpstudie",
    intro:
      "Iedereen die aan het water wil wonen, wil het water zien. Vanuit de keuken, vanaf de bank, het liefst ook vanuit bed. Tegelijk wil niemand dat elke voorbijvarende boot ziet wat je aan het eten bent. Die puzzel zien we vaak bij mensen met een kavel aan een plas of een vaart, en daarom hebben we hem een keer voor onszelf uitgetekend.",
    approach:
      "We hebben het huis zo op de kavel gezet dat de grote ramen naar het water kijken en de dichte kant naar de weg. Aan de waterkant loopt het glas over twee verdiepingen door, aan de straatkant blijft het huis dicht tot je binnen bent. Zo’n pui is voor de fabriek geen probleem, zolang de constructie erachter klopt, en daar hebben we op getekend.",
    progress:
      "Er is geen opdrachtgever, geen kavel en geen vergunning. Dit is een richting die laat zien hoe wij naar zo’n plek kijken. Heb je zelf een kavel aan het water, dan is dit ongeveer de eerste vraag die we je stellen: waar wil je naar kijken, en wie mag naar jou kijken.",
  },
  {
    slug: "villa-met-carport",
    title: "Strak en beschut",
    place: "Ontwerpstudie",
    status: "Ontwerpstudie",
    image: "/villa-carport.jpg",
    imageAlt: "Ontwerpimpressie van een moderne villa met carport",
    label: "Ontwerpstudie",
    intro:
      "Wie een strak, modern huis wil, tekent eerst de buitenkant. Rechte lijnen, een plat dak, een gevel zonder poespas. Wij hebben genoeg van die huizen gebouwd om te weten waar het vaak misgaat, en dat is bij de voordeur. Je komt thuis in de regen met boodschappen, twee kinderen en een hond, en dan blijkt de entree een strakke rechthoek zonder afdak.",
    approach:
      "Deze studie begint bij die voordeur. We hebben een carport en een overdekte entree in het huis zelf getekend, zodat je droog van de auto naar de keuken loopt zonder dat er iets tegen de gevel aan geplakt hoeft. Van buiten blijft het één strak blok. Voor de fabriek betekent zo’n inpandige carport dat de constructie erboven anders wordt, en dat is precies waarom we het uittekenen. Dat wil je weten voordat de tekening naar de gemeente gaat.",
    progress:
      "Er is geen opdrachtgever, geen kavel en geen vergunning. Wel een antwoord op een vraag die bijna iedereen met een strak ontwerp pas stelt als het huis er staat.",
  },
  {
    slug: "villa-aan-het-veld",
    title: "Landelijk met een eigen lijn",
    place: "Ontwerpstudie",
    status: "Ontwerpstudie",
    image: "/villa-water.jpg",
    imageAlt: "Ontwerpimpressie van een landelijke villa aan het water",
    label: "Ontwerpstudie",
    intro:
      "Aan de rand van een dorp of in het buitengebied schrijft de gemeente vaak voor hoe een huis eruit moet zien: een kap, een nok, een goot op een bepaalde hoogte. Van buiten moet het bij de boerderijen verderop passen. Binnen wil bijna niemand meer wonen zoals in een boerderij. Je wilt hoog, licht en open, met de keuken en de woonkamer in één ruimte.",
    approach:
      "Die twee wensen vechten om de constructie. Een grote open ruimte onder een kap betekent dat het dak over een lange afstand moet dragen zonder tussenmuur. In houtskeletbouw kan dat tot een bepaalde maat, daarna komt er staal in. We hebben in deze studie getekend waar die grens ligt en wat je dan krijgt: een kap die van buiten bij het landschap past en een binnenkant die er niets van heeft.",
    progress:
      "Er is geen opdrachtgever, geen kavel en geen vergunning. Wel een antwoord op een vraag die we vaak krijgen van mensen met een kavel waar de gemeente iets over de kap heeft gezegd.",
  },
] as const;

export const routeSteps = [
  {
    number: "01",
    title: "Je stuurt wat je hebt",
    text: "Een kavelnummer, een schets op ruitjespapier, een compleet ontwerp van je architect. Je begint met wat je al hebt.",
    deliverable: "We nemen contact op",
  },
  {
    number: "02",
    title: "Wij lezen je plan",
    text: "We leggen je ontwerp, je kavel, de constructie en de fabriek naast elkaar. Daaruit volgt of het kan, en in welke buurt het bedrag ligt.",
    deliverable: "Ja of nee, met een bedrag erbij",
  },
  {
    number: "03",
    title: "Samen door je plan",
    text: "Is de richting kansrijk, dan zit je kosteloos met onze lead architect aan tafel. Met je eigen architect erbij als die betrokken is. We lopen het plan door tot de keuzes en vragen op tafel liggen.",
    deliverable: "Een plan dat is doorgesproken",
  },
  {
    number: "04",
    title: "We maken het productieklaar",
    text: "Kies je ervoor om verder te gaan, dan maken we de werktekeningen en constructieberekeningen voor € 1.500. Voor € 750 stellen we een gedetailleerde begroting op. Daarmee worden de prijs, een sluitende planning tot op de bouwdag en de productieset concreet. Je krijgt de tekeningen en begroting mee, ook als je niet met ons verdergaat.",
    deliverable: "Tekeningen, begroting en productieset",
  },
  {
    number: "05",
    title: "Het huis wordt gemaakt",
    text: "Per dag bouwen we op locatie ongeveer 50 m². Dat is wat op een efficiënt ingerichte vrachtwagen past. Laat de bouwplaats het toe, dan schalen we op over meer stramienen: herhaalbare bouwvakken.",
    deliverable: "Een huis dat er staat",
  },
] as const;

export const projectRoutes = [
  {
    slug: "kavel",
    eyebrow: "Ik heb een kavel",
    title: "De plek is er. Het plan nog niet.",
    text: "Je krijgt zicht op wat hier mag, wat maakbaar is en welk budget bij de kavel past.",
    cta: "Dit ben ik",
  },
  {
    slug: "ontwerp",
    eyebrow: "Ik heb een ontwerp",
    title: "Het huis staat op papier.",
    text: "Je krijgt een toets op prefab-maakbaarheid, zonder dat jouw ontwerp een cataloguswoning wordt.",
    cta: "Dit ben ik",
  },
  {
    slug: "bouwrijp",
    eyebrow: "Ik kan gaan bouwen",
    title: "De vergunning is rond.",
    text: "Je krijgt een productieplanning, een heldere rolverdeling en zicht op het montagetempo.",
    cta: "Dit ben ik",
  },
] as const;

export const translationCards = [
  { number: "01", title: "De essentie van het ontwerp blijft leidend", body: "We beginnen bij wat jij niet wilt verliezen: de vorm, ruimtelijkheid en kenmerken die jouw woning bijzonder maken.", image: "/fabriek-ontwerp-woning-met-vlag.jpg", alt: "Afgewerkte woning met een hoge kap en Nederlandse vlag" },
  { number: "02", title: "We ontwerpen de technische route", body: "We vertalen vorm en ruimte naar constructie, elementen, verbindingen, installaties en productietekeningen.", image: "/fabriek-materialen-kentalis.jpg", alt: "Houten bouwelementen en materialen klaar voor montage bij Kentalis" },
  { number: "03", title: "We maken de uitvoering organiseerbaar", body: "We verbinden fabriek, transport, kraan, fundering, montage en afbouw tot één uitvoerbaar plan.", image: "/fabriek-kraan-kentalis.jpg", alt: "Kraan hijst een houten bouwelement bij Kentalis" },
  { number: "04", title: "Je bouwt met wie bij je plan past", body: "Heb je al een aannemer? Dan kan die de bouw uitvoeren. eVilla blijft betrokken bij je plan en de afspraken die we samen maken.", image: "/hero-villa-bos.jpg", alt: "Volledig afgewerkte moderne woning aan de bosrand" },
] as const;

export const timelinePhases = [
  {
    number: "01",
    title: "Plancheck en architectgesprek",
    duration: "2 tot 6 weken",
    text: "Je legt je plan voor. Na de eerste check zit je kosteloos met onze lead architect aan tafel, met je eigen architect erbij als die betrokken is. Zo krijgen alle ontwerpkeuzes een plek voordat de technische uitwerking begint.",
  },
  {
    number: "02",
    title: "Technisch ontwerp en begroting",
    duration: "3 tot 6 maanden",
    text: "Kies je ervoor om verder te gaan, dan maken we werktekeningen en constructieberekeningen voor € 1.500. De gedetailleerde begroting kost € 750. Zo ontstaan een productieset, een concrete prijs en een planning tot op de bouwdag. De gemeente beslist over de vergunning; dat tempo hebben wij niet in de hand.",
  },
  {
    number: "03",
    title: "Productie en montage",
    duration: "60 tot 90 dagen",
    text: "Na een onherroepelijke vergunning maakt de fabriek jouw elementen en zet de bouwploeg ze op je kavel. Dan staat er een wind- en waterdichte woning.",
  },
  {
    number: "04",
    title: "Afbouw",
    duration: "Weken tot eigen tempo",
    text: "WoonKlaar: enkele weken tot de sleutel. KlusKlaar: jouw planning, jouw tempo. Je kunt in fases werken terwijl je er al zit.",
  },
] as const;

export const timelineTotal =
  "De bouw is kort. Het papierwerk niet. WoonKlaar: reken op negen tot veertien maanden tot de sleutel. KlusKlaar staat na zes tot tien maanden wind- en waterdicht. Bij CascoKlaar bepalen de vergunning, de fundering en de afspraken over de afbouw de planning. Allemaal richttijden, geen opleverdatum.";

export const packages = [
  {
    name: "CascoKlaar",
    eyebrow: "De constructieve kern",
    tagline: "Voor wie de afbouw zelf regelt",
    price: "± € 487 per m³",
    image: "/bouw-overzicht.jpg",
    imageAlt: "Prefab woning in aanbouw met zichtbare houten constructie",
    pricePerM3: 487,
    priceNote: "Richtprijs · woninginhoud · scope per project",
    summary:
      "De constructieve kern van je huis, in de fabriek gemaakt en met de kraan gemonteerd op de fundering die er al ligt. Technische tekeningen en berekeningen zitten erin. Fundering, installaties en afbouw vallen buiten CascoKlaar; wij leggen vooraf vast hoe die onderdelen op onze montage aansluiten.",
    time: "Montage van de kern: dagen tot enkele weken",
    includes: [
      "Technische tekeningen en berekeningen",
      "Voorbereiding van de vergunningaanvraag",
      "Productie prefab elementen (HSB of staalframe)",
      "Kozijnen met triple beglazing, voorgemonteerd",
      "Leidingen in de wanden voorbereid",
      "Transport, kraan en montage op je kavel",
    ],
    excludes: [
      "Fundering en grondwerk",
      "Installaties en afbouw",
    ],
  },
  {
    name: "KlusKlaar",
    eyebrow: "Wind- en waterdicht",
    tagline: "Voor wie zelf wil afbouwen",
    price: "€ 680 per m³",
    image: "/werk-woonkamer.jpg",
    imageAlt: "Woning die wind- en waterdicht is, klaar voor de binnenafwerking",
    pricePerM3: 680,
    priceNote: "Richtprijs incl. btw · woninginhoud",
    summary:
      "Een complete, wind- en waterdichte woning: ontwerp, vergunning, fundering, wanden, vloeren en dak. De leidingen zitten in de wanden. De binnenafwerking doe jij, in je eigen tempo, met je eigen budget.",
    time: "Wind- en waterdicht: ± 6 tot 10 maanden na het eerste gesprek",
    includes: [
      "Schetsontwerp, tekeningen en berekeningen",
      "Aanvraag omgevingsvergunning",
      "Grondwerk, fundering en begane-grondvloer",
      "Prefab wanden en vloeren, dak waterdicht, luchtdicht gebouwd",
      "Kozijnen met triple beglazing",
      "Leidingen en aansluitingen voorbereid",
    ],
    excludes: [
      "Complete installaties en meterkast",
      "Dekvloer, trap, binnendeuren en binnenafwerking",
      "Keuken, sanitair en tegelwerk",
    ],
  },
  {
    name: "WoonKlaar",
    eyebrow: "Meest compleet",
    tagline: "Voor wie wil verhuizen, niet klussen",
    price: "€ 825 per m³",
    image: "/villa-trompenberg-hilversum.jpg",
    imageAlt: "Villa Trompenberg in Hilversum",
    pricePerM3: 825,
    priceNote: "Richtprijs incl. btw · woninginhoud",
    summary:
      "Alles van KlusKlaar, plus de complete afbouw: installaties, warmtepomp, vloerverwarming, dekvloer, trap, binnendeuren, wand- en vloerafwerking, en de plaatsing van keuken en badkamer. Jij kiest de materialen, daarna verhuis je.",
    time: "Sleutel: ± 9 tot 14 maanden na het eerste gesprek",
    includes: [
      "Alles van KlusKlaar",
      "Complete installaties, meterkast en verlichtingspunten",
      "Warmtepomp, vloerverwarming, WTW en zonnepanelen",
      "Dekvloer, trap, binnendeuren en aftimmering",
      "Wandafwerking, tegelwerk en schilderwerk",
      "Keuken en badkamer geplaatst en aangesloten",
    ],
    excludes: [
      "Aanschafbudget keuken, sanitair en tegels (stelpost, jouw keuze)",
      "Kelder en bijzondere funderingen",
      "Tuin, bestrating en losse specials",
    ],
  },
] as const;

export const packageNotes = [
  "De richtprijzen zijn ons startpunt, prijspeil 2026, gerekend per kubieke meter woninginhoud. KlusKlaar en WoonKlaar inclusief btw. Het zijn startpunten voor het gesprek, geen offerte. Bij CascoKlaar hangt het bedrag af van de scope per project.",
  "Nooit inbegrepen, bij geen enkel pakket: de kavel, leges en gemeentelijke kosten, een kelder, het aanschafbudget voor keuken, sanitair en tegels, luxe specials en tuin of bestrating. Die staan apart op de offerte.",
  "Voor je tekent krijg je van ons de demarcatietabel: per onderdeel één van zes antwoorden, zodat je precies ziet wat erin zit, wat een keuze is en wat erbuiten valt.",
] as const;

export const packagePlans = [
  {
    name: "CascoKlaar",
    lead: "Je kiest CascoKlaar als fundering, installaties en afbouw buiten onze levering blijven. Wij maken je ontwerp productieklaar, leveren de prefab kern en houden de aansluiting met de volgende bouwfase scherp.",
    end: "Aan het eind staat de prefab kern gemonteerd op je fundering. De onderdelen buiten CascoKlaar worden daarna uitgevoerd volgens de afspraken die we vooraf met je hebben vastgelegd.",
    steps: [
      {
        title: "Scope en demarcatie",
        duration: "2 tot 6 weken",
        who: "Samen",
        text: "We leggen per onderdeel vast wat CascoKlaar omvat en hoe fundering, dak, installaties en afbouw daarop aansluiten. Zo weet iedereen vóór de start wat er nog nodig is.",
      },
      {
        title: "Technische uitwerking en productie",
        duration: "Na jouw onherroepelijke vergunning",
        who: "Wij",
        text: "We werken je ontwerp uit tot technische tekeningen en berekeningen waarmee de fabriek kan produceren. De fundering moet gereed zijn voor montage; wanneer die buiten CascoKlaar wordt uitgevoerd, stemmen we de aansluiting daarop af.",
      },
      {
        title: "Transport en montage",
        duration: "Dagen tot enkele weken",
        who: "Wij",
        text: "De elementen komen per vrachtwagen, de kraan zet ze op je gereedliggende fundering en onze monteurs stellen en verankeren ze.",
      },
      {
        title: "Verder bouwen",
        duration: "Jouw planning",
        who: "Jij",
        text: "Gevelafwerking, installaties en afbouw vallen buiten CascoKlaar. Je kiest wie die uitvoert; wij blijven betrokken bij de aansluiting op de prefab kern en de afspraken uit stap één.",
      },
    ],
  },
  {
    name: "KlusKlaar",
    lead: "Wij brengen je van plan tot wind- en waterdichte woning. De binnenafwerking doe jij, in je eigen tempo.",
    end: "Wind- en waterdicht na ± 6 tot 10 maanden vanaf het eerste gesprek. Daarna bepaal jij het tempo.",
    steps: [
      {
        title: "Plancheck en schetsontwerp",
        duration: "2 tot 6 weken",
        who: "Samen",
        text: "We toetsen kavel, regels en maakbaarheid en werken samen naar een schetsontwerp dat de fabriek kan lezen.",
      },
      {
        title: "Technisch ontwerp en vergunning",
        duration: "3 tot 6 maanden",
        who: "Wij",
        text: "Tekeningen, berekeningen en de vergunningaanvraag. De gemeente beslist. Dat tempo hebben wij niet in de hand.",
      },
      {
        title: "Fundering, wanden en dak",
        duration: "60 tot 90 dagen",
        who: "Wij",
        text: "Na een onherroepelijke vergunning: grondwerk, fundering, productie en montage. Dan staat er een wind- en waterdichte woning met voorbereide leidingen.",
      },
      {
        title: "Afbouw",
        duration: "Jouw tempo",
        who: "Jij",
        text: "Installaties, dekvloer, trap, keuken en badkamer: jouw planning, jouw vakmensen, jouw budget. Je kunt in fases werken terwijl je er al zit.",
      },
    ],
  },
  {
    name: "WoonKlaar",
    lead: "Eén aanspreekpunt van eerste gesprek tot sleutel. Jij kiest de materialen, wij doen de rest.",
    end: "Sleutel na ± 9 tot 14 maanden vanaf het eerste gesprek. Vergunning en financiering bepalen waar je in die marge uitkomt.",
    steps: [
      {
        title: "Plancheck en schetsontwerp",
        duration: "2 tot 6 weken",
        who: "Samen",
        text: "We toetsen kavel, regels en maakbaarheid en werken samen naar een schetsontwerp dat de fabriek kan lezen.",
      },
      {
        title: "Technisch ontwerp en vergunning",
        duration: "3 tot 6 maanden",
        who: "Wij",
        text: "Tekeningen, berekeningen en de vergunningaanvraag. In deze fase kies je met onze kopersbegeleiding ook je keuken, sanitair en tegels, zodat dat straks niet wacht.",
      },
      {
        title: "Fundering, wanden en dak",
        duration: "60 tot 90 dagen",
        who: "Wij",
        text: "Na een onherroepelijke vergunning: grondwerk, fundering, productie en montage. Dan staat er een wind- en waterdichte woning.",
      },
      {
        title: "Complete afbouw",
        duration: "Enkele weken",
        who: "Wij",
        text: "Installaties, warmtepomp, vloerverwarming, dekvloer, trap, tegelwerk, keuken en badkamer. Daarna oplevering, en verhuizen.",
      },
    ],
  },
] as const;

type CmpCell = "yes" | "no" | "project";

export const comparisonGroups: {
  group: string;
  rows: { label: string; cells: [CmpCell, CmpCell, CmpCell] }[];
}[] = [
  {
    group: "Ontwerp en voorbereiding",
    rows: [
      { label: "Schetsontwerp en haalbaarheid", cells: ["project", "yes", "yes"] },
      { label: "Technische tekeningen en berekeningen", cells: ["project", "yes", "yes"] },
      { label: "Aanvraag omgevingsvergunning en nutsaansluitingen", cells: ["project", "yes", "yes"] },
      { label: "Werkvoorbereiding, coördinatie en oplevering", cells: ["project", "yes", "yes"] },
    ],
  },
  {
    group: "Terrein en fundering",
    rows: [
      { label: "Bouwplaatsinrichting, bouwstroom en riool", cells: ["project", "yes", "yes"] },
      { label: "Grondwerk, fundering en begane-grondvloer", cells: ["no", "yes", "yes"] },
    ],
  },
  {
    group: "De prefab kern",
    rows: [
      { label: "Productie prefab elementen (HSB of staalframe)", cells: ["yes", "yes", "yes"] },
      { label: "Transport, kraan en montage op maat", cells: ["yes", "yes", "yes"] },
      { label: "Kozijnen inclusief triple beglazing", cells: ["yes", "yes", "yes"] },
      { label: "Luchtdicht gebouwd, hoogwaardig geïsoleerd", cells: ["yes", "yes", "yes"] },
      { label: "Leidingen voorgemonteerd in de wanden", cells: ["yes", "yes", "yes"] },
      { label: "Dak waterdicht, woning wind- en waterdicht", cells: ["project", "yes", "yes"] },
    ],
  },
  {
    group: "Buitenafwerking",
    rows: [
      { label: "Gevelafwerking aangebracht", cells: ["no", "project", "yes"] },
      { label: "Definitieve dakbedekking, goten en overstekken", cells: ["no", "project", "yes"] },
    ],
  },
  {
    group: "Installaties en afbouw",
    rows: [
      { label: "Complete installaties en meterkast", cells: ["no", "no", "yes"] },
      { label: "Warmtepomp, vloerverwarming, WTW en zonnepanelen", cells: ["no", "no", "yes"] },
      { label: "Dekvloer, trap, binnendeuren en binnenaftimmering", cells: ["no", "no", "yes"] },
      { label: "Wandafwerking, tegelwerk en schilderwerk", cells: ["no", "no", "yes"] },
      { label: "Keuken en badkamer geplaatst en aangesloten", cells: ["no", "no", "yes"] },
    ],
  },
] as const;

export const faq = [
  {
    q: "Moet ik kiezen uit een catalogus?",
    a: "Nee. Jouw ontwerp is het vertrekpunt. Soms moet een detail wijken omdat de vrachtwagen er niet omheen kan of de fabriek het niet kan maken. Dan hoor je dat meteen.",
  },
  {
    q: "Kan mijn ontwerp echt prefab?",
    a: "Vaak wel, soms deels, af en toe niet. Dat hangt af van je vorm, maatvoering, constructie en hoe goed je kavel bereikbaar is voor een kraan en een vrachtwagen. We zeggen het liever nu dan over drie maanden.",
  },
  {
    q: "Wat doet eVilla precies?",
    a: "Je wilt niet dat je ontwerp onderweg uit beeld raakt. Daarom verzorgen we het hele traject: van tekeningen en vergunningsaanvraag tot bouw en nazorg. We werken daarbij met partners. Vraagt jouw project om een bouwende partner of een rechtstreeks contract, dan leggen we dat vooraf helder vast. Wij blijven betrokken bij het plan, de afspraken en de standaard die we samen hebben bepaald.",
  },
  {
    q: "Wanneer weet ik wat het kost?",
    a: "Bij het eerste antwoord al. Iedereen die zijn plan voorlegt krijgt dezelfde twee dingen terug: of het kan, en wat het ongeveer kost, uitgesplitst per onderdeel. We rekenen met richtprijzen per kubieke meter: CascoKlaar rond de € 487, KlusKlaar € 680 en WoonKlaar € 825 per m³ (KlusKlaar en WoonKlaar inclusief btw). Een woning van 750 m³ zit dus tussen ± € 365.000 voor alleen de kern en ± € 620.000 sleutelklaar. Dat is een startpunt, geen offerte. Jouw ontwerp, kavel en keuzes bepalen het echte bedrag. Wat er niet in zit, staat ernaast.",
  },
  {
    q: "Hoe lang duurt het?",
    a: "Dat hangt af van je manier van werken. De bouw is overal het korte stuk: na een onherroepelijke vergunning staat de woning er wind- en waterdicht in 60 tot 90 dagen. WoonKlaar: reken van eerste gesprek tot sleutel op negen tot veertien maanden. KlusKlaar: na zes tot tien maanden wind- en waterdicht, daarna jouw tempo. CascoKlaar: de vergunning, fundering en afbouwafspraken bepalen de planning. Per fase krijg je een termijn, toegesneden op jouw plan en jouw gemeente.",
  },
  {
    q: "Zit er garantie op mijn huis?",
    a: "Voor je tekent, leggen we vast hoe jouw project is georganiseerd en welke garantie daarbij hoort. Als een bouwende partner de garantie verstrekt, staat in je overeenkomst wat die dekt en hoe lang die loopt. Soms is een rechtstreeks contract met die partner logisch. Ook dan blijven wij betrokken bij het plan, de afspraken en de standaard die we samen hebben bepaald.",
  },
  {
    q: "Wat doen jullie niet?",
    a: "We leveren geen cataloguswoning. We beloven geen vergunning, die geeft de gemeente. We zijn niet de goedkoopste en proberen dat ook niet te worden. We vinden het erger als je een huis hebt waar het systeem niet bij past.",
  },
] as const;
export const builtProjects = [
  {
    image: "/gebouwd-almere-hout-v2.jpg",
    alt: "Vrijstaande woning met houten gevel en een puntdak met grote glaspui",
    place: "Almere",
    kind: "Houtskeletbouw",
    line: "Hout tot aan de nok, en een pui die over twee verdiepingen doorloopt.",
    isHome: true,
  },
  {
    image: "/gebouwd-apeldoorn-zonnehoeve-v2.jpg",
    alt: "Woning met witte gevel, houten inbouwcarport en een auto op de oprit",
    place: "Apeldoorn",
    kind: "Houtskeletbouw",
    line: "De carport zit in het volume, niet ertegenaan geplakt.",
    isHome: true,
  },
  {
    image: "/gebouwd-almere-belle-v2.jpg",
    alt: "Rij witte woningen met platte daken langs een groene berm",
    place: "Almere",
    kind: "Drie woningen op een rij",
    line: "Drie woningen naast elkaar, alle drie met een eigen plattegrond.",
    isHome: true,
  },
  {
    image: "/gebouwd-amsterdam-woonarken-v2.jpg",
    alt: "Woonarken met houten gevels aan het water, met vlonders en balkons",
    place: "Amsterdam",
    kind: "Veertien woonarken",
    line: "Veertien arken op het water. Alles moest kloppen voordat de eerste te water ging.",
    isHome: true,
  },
  {
    image: "/gebouwd-amsterdam-staalframe-v2.jpg",
    alt: "Woonarken met witte en houten volumes aan een kade",
    place: "Amsterdam",
    kind: "Staalframebouw, zes woningen",
    line: "Zes woningen in staalframe, omdat het ontwerp de overspanning vroeg.",
    isHome: true,
  },
  {
    image: "/gebouwd-amsterdam-koopvaarders-v2.jpg",
    alt: "Blok met woningen van drie lagen, donkere gevel, in de ochtendzon",
    place: "Amsterdam",
    kind: "Gestapelde woningen",
    line: "Drie lagen stapelen vraagt een fabriek die op de millimeter levert.",
    isHome: true,
  },
  {
    image: "/gebouwd-naarden-school-v2.jpg",
    alt: "Schoolgebouw met een gevel van gekantelde houten lamellen",
    place: "Naarden",
    kind: "School",
    line: "Een gevel die kantelt. In prefab betekent dat: elk element is anders.",
    isHome: false,
  },
  {
    image: "/gebouwd-sint-michielsgestel-kentalis-v2.jpg",
    alt: "Wit gebouw met houten kozijnen voor dagbesteding, met ruime entree",
    place: "Sint-Michielsgestel",
    kind: "Dagbesteding",
    line: "Zorgbouw met een strak schema: elke week dat het eerder open kan, telt.",
    isHome: false,
  },
  {
    image: "/gebouwd-apeldoorn-appartementen-v2.jpg",
    alt: "Appartementengebouw van vier lagen met houten gevelbekleding",
    place: "Apeldoorn",
    kind: "Dertig appartementen",
    line: "Dertig appartementen, dezelfde manier van maken als één villa.",
    isHome: true,
  },
] as const;

export const builtHomes = builtProjects.filter((project) => project.isHome);

export const mapPins = [
  { name: "Oosterwolde", x: 75.9, y: 19.3, side: "left" },
  { name: "Amsterdam", x: 39.8, y: 42.3, side: "left" },
  { name: "Almere", x: 48.1, y: 40.4, side: "right" },
  { name: "Naarden", x: 46.7, y: 46.6, side: "left" },
  { name: "Zeewolde", x: 56.5, y: 43.7, side: "right" },
  { name: "Apeldoorn", x: 67.5, y: 48.0, side: "right", building: true },
  { name: "Sint-Michielsgestel", x: 51.7, y: 68.6, side: "left" },
  { name: "Nuenen", x: 56.8, y: 74.5, side: "right" },
] as const;

export const routeChoices = [
  {
    title: "Ik heb een kavel",
    subtitle: "De grond is er, het huis nog niet.",
    image: "/kavel-card.jpg",
    imageAlt: "Een groen grasveld met een ruime kavel in het zonlicht",
    body: "De grond is er, het huis nog niet. We kijken samen of een kraan er überhaupt bij kan, wat de gemeente op deze plek toestaat en hoeveel er van je budget overblijft voor het huis zelf.",
  },
  {
    title: "Ik heb een ontwerp",
    subtitle: "Je tekening ligt er.",
    image: null,
    imageAlt: null,
    body: "Je tekening ligt er. Wij lopen hem lijn voor lijn door en vertellen je wat er zo de fabriek in kan en waar een aanpassing nodig is. Je hoge woonkamer gaat daarbij niet omlaag.",
  },
  {
    title: "Ik mag bouwen",
    subtitle: "De vergunning is binnen en de kavel is van jou.",
    image: "/bouw-spant.jpg",
    imageAlt: "Een prefab woning in opbouw met het frame zichtbaar",
    body: "De vergunning is binnen en de kavel is van jou. Het lange wachten is voorbij. Nu gaan we een plek in de fabriek voor je zoeken.",
  },
] as const;

export const socials = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/evillabenelux", icon: "linkedin" },
] as const;

export const beurs = {
  title: "Beurs Eigen Huis",
  dates: "9, 10 en 11 oktober 2026",
  place: "Jaarbeurs Utrecht, hal 3 en 4",
  offer: "We staan er weer, met tekeningen op tafel. Onze kaarten zijn gratis, zolang ze er zijn.",
};

export const openDays = {
  place: "Apeldoorn",
  months: "september, oktober en november 2026",
  what: "Een woning in aanbouw, van binnen te zien voordat de afwerking eroverheen gaat.",
  who: "Voor mensen met een bouwplan, en voor architecten en aannemers die met ons willen werken.",
  rule: "Alleen op afspraak, op een van de open dagen.",
};
